import { SliceZone } from '@prismicio/react'
import React from 'react'

import { components } from '../../../slices'
import NextHeader from '../../components/NextHeader'
import { getPageSEOData } from '../../utils/seo-helpers'
import { Language } from '../../types/Types'
import { ICrumb } from '../../components/BreadCrumbs'
import { PageDocument } from '../../../prismicio-types'
interface IProps {
	page: PageDocument
	locale: Language
	crumbs: ICrumb[]
}

const GeneralPage: React.FC<IProps> = ({ page, crumbs }: IProps) => {
	return (
		<>
			<NextHeader {...getPageSEOData(page)} />
			<SliceZone
				slices={page.data.slices}
				components={components}
				context={{ page, crumbs }}
			/>
		</>
	)
}

export default GeneralPage
